import React from 'react';
import { MapPin, Radio } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const LocationSelector = ({ drillPath, onSelect, states, counties, precincts }) => {
  return (
    <div className="p-4 space-y-4">
      <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider flex items-center gap-2">
        <MapPin className="w-4 h-4 text-teal-400" />
        Location Drill-Down
      </h3>
      
      {/* States list */}
      {drillPath.level === 'usa' && states && (
        <div className="space-y-1 max-h-[300px] overflow-y-auto">
          {states.slice(0, 15).map(state => (
            <button
              key={state.code}
              onClick={() => onSelect('state', state.code)}
              className="w-full flex items-center justify-between p-2 rounded hover:bg-slate-800 transition-colors"
            >
              <span className="text-sm text-slate-300">{state.name}</span>
              <Badge variant="secondary" className="bg-slate-700 text-slate-300">
                {state.incident_count || 0}
              </Badge>
            </button>
          ))}
        </div>
      )}
      
      {/* Counties list */}
      {drillPath.level === 'state' && counties && (
        <div className="space-y-1 max-h-[300px] overflow-y-auto">
          {counties.map(county => (
            <button
              key={county.name}
              onClick={() => onSelect('county', county.name)}
              className="w-full flex items-center justify-between p-2 rounded hover:bg-slate-800 transition-colors"
            >
              <span className="text-sm text-slate-300">{county.name}</span>
              <Badge variant="secondary" className="bg-slate-700 text-slate-300">
                {county.incident_count || 0}
              </Badge>
            </button>
          ))}
        </div>
      )}
      
      {/* Precincts list */}
      {drillPath.level === 'county' && precincts && (
        <div className="space-y-1 max-h-[300px] overflow-y-auto">
          {precincts.map(precinct => (
            <button
              key={precinct.name}
              onClick={() => onSelect('precinct', precinct.name)}
              className="w-full flex items-center justify-between p-2 rounded hover:bg-slate-800 transition-colors"
            >
              <div className="flex items-center gap-2">
                <Radio className="w-3 h-3 text-teal-400" />
                <span className="text-sm text-slate-300">{precinct.name}</span>
              </div>
              <Badge variant="secondary" className="bg-slate-700 text-slate-300">
                {precinct.incident_count || 0}
              </Badge>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationSelector;
